import { toast } from "sonner";

function recipeText(r) {
  const yieldLine = r.yield_g != null ? `Espresso Yield: ${r.yield_g} g` : `Water: ${r.water} ml`;
  const lines = [
    r.name,
    `Brewer: ${r.brewer}`,
    `Mode: ${r.mode === "guided" ? "Guided Recipe" : "Custom Brew"}`,
    `Roast: ${r.roast}`,
    `Coffee: ${r.coffee} g`,
    yieldLine,
    `Ratio: 1:${r.ratio}`,
    `Grind: ${r.grind}`,
    `Temperature: ${r.temperature}°C`,
  ];
  (r.instructions || []).forEach((s, i) => lines.push(`${i + 1}. ${s.label}: ${s.instruction}`));
  if (r.notes) lines.push("", `Recipe notes: ${r.notes}`);
  if (r.brew_notes) lines.push("", `Brew notes: ${r.brew_notes}`);
  if (r.tasting_notes) lines.push("", `Tasting notes: ${r.tasting_notes}`);
  lines.push("", "Made with BrewMate, powered by Wonderbean Coffee Co.");
  return lines.join("\n");
}

export function downloadRecipe(r) {
  const safeName = (r.name || "BrewMate recipe").replace(/[\\/:*?"<>|]+/g, "-").trim();
  const blob = new Blob([recipeText(r)], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${safeName || "BrewMate recipe"}.txt`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
  toast.success("Recipe downloaded");
}

export async function shareRecipe(r) {
  const text = recipeText(r);
  if (navigator.share) {
    try {
      await navigator.share({ title: r.name, text });
      return;
    } catch (e) {
      if (e && e.name === "AbortError") return;
    }
  }
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Recipe copied to clipboard");
  } catch {
    toast.error("Sharing is not supported on this device");
  }
}

export function printRecipe(r) {
  const yieldLine = r.yield_g != null ? `<tr><td>Espresso Yield</td><td>${r.yield_g} g</td></tr>` : `<tr><td>Water</td><td>${r.water} ml</td></tr>`;
  const steps = (r.instructions || [])
    .map((s, i) => `<li><strong>${s.label}</strong> — ${s.instruction} <span class="s">(${s.seconds}s)</span></li>`)
    .join("");
  const notes = r.notes ? `<div class="card"><strong>Recipe notes</strong><p>${escapeHtml(r.notes)}</p></div>` : "";
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${r.name}</title>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600&family=Plus+Jakarta+Sans:wght@400;600&display=swap');
    body{font-family:'Plus Jakarta Sans',sans-serif;color:#152669;padding:32px;max-width:640px;margin:0 auto}
    h1{font-family:'Playfair Display',serif;font-weight:600;margin:0}
    .brand{color:#152669;font-weight:600;letter-spacing:.02em}
    .card{border:1px solid rgba(20,9,81,.2);border-radius:16px;padding:20px;margin-top:20px}
    table{width:100%;border-collapse:collapse}
    td{padding:6px 0;border-bottom:1px solid rgba(20,9,81,.12)}
    td:first-child{color:#377A98}
    ol{padding-left:20px;line-height:1.6}
    .s{color:#4EADAF}
    .foot{margin-top:24px;color:#377A98;font-size:13px}
  </style></head><body>
    <div class="brand">Powered by Wonderbean Coffee Co.</div>
    <h1>${r.name}</h1>
    <div class="card"><table>
      <tr><td>Brewer</td><td>${r.brewer}</td></tr>
      <tr><td>Mode</td><td>${r.mode === "guided" ? "Guided Recipe" : "Custom Brew"}</td></tr>
      <tr><td>Roast</td><td>${r.roast}</td></tr>
      <tr><td>Coffee</td><td>${r.coffee} g</td></tr>
      ${yieldLine}
      <tr><td>Ratio</td><td>1:${r.ratio}</td></tr>
      <tr><td>Grind</td><td>${r.grind}</td></tr>
      <tr><td>Temperature</td><td>${r.temperature}°C</td></tr>
    </table></div>
    <div class="card"><ol>${steps}</ol></div>
    ${notes}
    <div class="foot">Made with BrewMate, powered by Wonderbean Coffee Co.</div>
  </body></html>`;
  const w = window.open("", "_blank");
  if (!w) {
    toast.error("Please allow pop-ups to print");
    return;
  }
  w.document.write(html);
  w.document.close();
  setTimeout(() => w.print(), 400);
}

function escapeHtml(value) {
  return String(value).replace(/[&<>'"]/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }[char]));
}
